"use client";
import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function TanstackProvider({ children }: { children: React.ReactNode }) {
  const [client] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Default staleTime is 0, which means every window refocus (very
            // common while writing — switching tabs, alt-tabbing, etc.)
            // re-fetches every mounted query from the DB. 60s avoids that
            // refetch storm while still picking up changes made elsewhere
            // (explicit mutations already invalidateQueries and refetch
            // immediately regardless of staleTime).
            staleTime: 60 * 1000,
          },
        },
      })
  );
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

export default TanstackProvider;
